<template>
  <SeoPage page-key="webDesignLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'WebDesignLuganoPage'
})
</script>



